import { render } from "./ApplyBeta.vue?vue&type=template&id=5b869b10&scoped=true"
import script from "./ApplyBeta.vue?vue&type=script&lang=js"
export * from "./ApplyBeta.vue?vue&type=script&lang=js"

import "./ApplyBeta.vue?vue&type=style&index=0&id=5b869b10&scoped=true&lang=less"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b869b10"]])

export default __exports__